import { stripHtmlText } from './htmlText';

export const POLICY_LABELS = {
  cancellation: 'Cancellation Policy',
  terms: 'Terms & Conditions',
  refund: 'Refund Policy',
  privacy: 'Privacy Policy',
  how_it_work: 'How it works',
};

export function isKnownPolicyType(type) {
  return Boolean(type && Object.prototype.hasOwnProperty.call(POLICY_LABELS, type));
}

export function mapPolicy(response, fallbackType) {
  const payload = response?.data?.policy || response?.data || {};

  return {
    title: payload.title || POLICY_LABELS[fallbackType] || 'Policy',
    content: payload.content || payload.body || payload.description || '',
    type: payload.type || payload.policy_type || fallbackType || '',
    updatedAt: payload.updated_at || payload.updatedAt || null,
  };
}

export function mapAchievementStats(stats) {
  if (!Array.isArray(stats)) return [];

  return stats
    .map((stat, index) => ({
      id: stat?.id ?? `stat-${index}`,
      value: String(stat?.value ?? '').trim(),
      label: String(stat?.label ?? '').trim(),
      position: Number(stat?.position) || index + 1,
    }))
    .filter((stat) => stat.value || stat.label)
    .sort((a, b) => a.position - b.position);
}

export function mapAboutUs(response) {
  const payload = response?.data?.about_us || response?.data || {};

  return {
    title: payload.title || 'About Us',
    content:
      payload.content ||
      payload.body ||
      payload.description ||
      payload.about ||
      '',
    achievementStats: mapAchievementStats(payload.achievement_stats),
    announcement: stripHtmlText(payload.announcement),
    updatedAt: payload.updated_at || payload.updatedAt || null,
  };
}
